// Angular
import { ChangeDetectorRef, Component, EventEmitter, OnInit, ViewChild, Output, Input } from '@angular/core'
import { MatPaginator } from '@angular/material'
import { ActivatedRoute, Router } from '@angular/router'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
// Services
import { PanierLine } from '../../../../../Interfaces/Panier'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { InstructionService } from '../../../../../services/WebService/instruction.service'
import { LayoutConfigService } from '../../../../../core/_base/layout'
import { AppService, ConsultationService, ParameterService, StateService,ListeService } from '../../../../../services'
import { ConsultationSingleComponent } from '../../consultation/consultation-single/consultation-single.component'

import { LoadDialogComponent } from '../../../layout/dialogs/load-dialog/load.component'
import { DialogService } from '../../../../../services'
import { of,Observable, Subject,  } from 'rxjs'

const KEY = 'DASHBOARD'

@Component({
    selector: 'atyl-dashboard-tab-notification',
    templateUrl: './dashboard-tab-notification.component.html',
    styleUrls: ['dashboard-tab-notification.component.scss'],
})
@Stringable({
    path: 'views/pages/dashboard/dashboard',
    key: KEY,
})
export class DashboardTabNotificationComponent implements OnInit {
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator
    
    @StringableValues(KEY)
    strings: any

    @Input() parameters: any;
    	@Input() load: Observable<any>;
		
    inited = new EventEmitter<any>();
    @Output() lengthNotif: EventEmitter<number> = new EventEmitter<number>();
    @Output() rowClicked: EventEmitter<any> = new EventEmitter<any>();
    
   // @Output() lengthNotif :number = 0;
    loadingNotif: boolean=true;
    
    columnsNotification:any=[];
    dataNotification:any=[];
    PaginationNotification:number=10;
    currentPageNotification :number = 0;
    loadingNotification:boolean=false;
    sortNotification: any;
    lengthNotifCount:number = 0;

    disabledPanier:boolean=true;
    element:PanierLine[]=[];
    
	subrs:any[]=[];
	
	isExportCSV:boolean=false;
	isExportPDF:boolean=false;
	
    constructor(
        private layoutConfigService: LayoutConfigService,
        private parameterService: ParameterService,
        private stateService: StateService,
        private router: Router,
        private appService: AppService,
        private changeDetectorRef: ChangeDetectorRef,
        private activatedRoute: ActivatedRoute,
        private consultationService: ConsultationService,
        private instructionService:InstructionService,
		private dialogService: DialogService,
		private listeService:ListeService
    ) {
    }

    
    ngOnInit(): void {
        console.log('dashboard tab nofication', this.strings)
        this.getDataPage(this.currentPageNotification,true,true);
		this.subrs.push(
			this.load.subscribe((loading:any) => {
				console.log("DashboardTabNotificationComponent",loading)
				 if (loading.load!=undefined &&loading.load)  {
					if (loading.parameters!=undefined)
						this.parameters=loading.parameters;

			         
			         this.getDataPage(this.currentPageNotification,true);
				}	
		     
			})
		);
    }

    ngOnDestroy() {
		this.subrs.forEach( (sb: any) => {;
						     	sb.unsubscribe();
						 })
    }

    ngOnChanges(changes) {
        //this.getDataPage(0, false, false);
    }

    ngAfterViewInit() {
      // this.getDataPage(this.currentPageNotification,true);
    }

    getInitedEmitter() {
        return this.inited;
    }
    
    onPaged(table:any){
		this.PaginationNotification=table.pageSize;
        this.getDataPage(table.currentPage);
    }
    
    onCellClicked(event:any) {
		
	}
    onRowClickedInstruction(row:any) {

        let clickRow={
            row: row,
            origin: 'notification'
            
        }
		this.subrs.push(
		      this.appService.notifSeen(row.id).subscribe((res) => {
		              //  console.log("onRowClicked",clickRow)
		                this.rowClicked.emit(clickRow);
						this.subrs.push(
			                this.appService.getAllNotifications().subscribe((notifs) => {
											this.stateService.updateNotifications(notifs.result)
							})
						);	
		      
		       })
			);   
       
/*
        this.appService.notifSeen(row.id).subscribe((res) => {
        
                if(row["instruction.demande.dossier.tiers.type.code"] === 'ASSMAT')
                    this.router.navigate(['/home/assistmat/'+   row["instruction.demande.dossier.id"]]);
                else if(row["instruction.demande.dossier.tiers.type.code"] === 'EAJE')
                    this.router.navigate(['/home/eaje/'+    row["instruction.demande.dossier.id"]]);
                else if(row["instruction.demande.dossier.tiers.type.code"] === 'MAM')
                    this.router.navigate(['/home/mam/'+ row["instruction.demande.dossier.id"]]);
                else if(row["instruction.demande.dossier.tiers.type.code"] === 'GESTIONNAIRE')
                    this.router.navigate(['/home/gestionnaire/'+    row["instruction.demande.dossier.id"]]);
                else if(row["instruction.demande.dossier.tiers.type.code"] === 'STRUCTURE_GESTION')
                    this.router.navigate(['/home/structgestion/'+row["instruction.demande.dossier.id"]])
                else if(row["instruction.demande.dossier.tiers.type.code"] === 'RAM')
                    this.router.navigate(['/home/ram/'+row["instruction.demande.dossier.id"]]);
            }
        );
     */   
     
    }
    
    onHeaderClicked(sort:any) {
        this.sortNotification = {
          id : sort.active,
          direction : sort.direction.toUpperCase()
        }
        this.getDataPage(this.currentPageNotification);
    }
    
    /*
   TABLE OF NOTIICATION 
   */

    getDataPage(page:number=0,init:boolean=false,nodata:boolean=false) {
        let _options={
            page:page,
			pageSize:this.PaginationNotification,
            sorts: [this.sortNotification],
            filters: {
                zone: {value:this.parameters.zoneInput},
                tiers: {value:this.parameters.tiersInput},
                metier : {value:this.parameters.metierInput},
                enCours : {value:this.parameters.enCoursInput},
                procedure : {value:this.parameters.procedureInput},
                action : {value:this.parameters.actionInput},
                statut : {value:this.parameters.statutInput},
                commune : {value:this.parameters.communeInput},
				reference : {value:this.parameters.referenceInput},	
				alltiers: {value:this.parameters.allTiersInput},
				grouptiers: {value:this.parameters.allGroupTiersInput},
				groupListtiers: {value:this.parameters.allGroupTiersListInput},
				groupeTiers: {value:this.parameters.groupTiersInput},
            }
        };
        this.loadingNotification= true;
				console.log("DashboardTabNotificationComponent load",_options,this.parameters,nodata);
		this.subrs.push(
        this.listeService.get("NOTIFICATION",_options,nodata)
              .subscribe((list:JSONRpcResponse) => {
          //  this.loadingNotif = false;
            this.columnsNotification=list.result.columns;
            this.dataNotification=list.result.datas.datas;
            if(list.result.datas.meta){
                //this.lengthNotif=list.result.datas.meta.total;
                this.lengthNotif.emit(list.result.datas.meta.total);
                this.lengthNotifCount=list.result.datas.meta.total;
                this.PaginationNotification=list.result.datas.meta.perpage;
                this.currentPageNotification=list.result.datas.meta.page;
                
            }
			if (list.result.options!=undefined 
					&& list.result.options.parameters!=undefined 
					&& list.result.options.parameters.export!=undefined 
					&& Array.isArray(list.result.options.parameters.export) ) {
					this.isExportCSV=(list.result.options.parameters.export.includes("CSV") || list.result.options.parameters.export.includes("XLSX"));
					this.isExportPDF=(list.result.options.parameters.export.includes("PDF"));
					console.log('load data export', list.result.options.parameters.export, this.isExportPDF,this.isExportCSV)						
			}
            this.loadingNotif=false;
            this.loadingNotification = false;
            this.inited.emit(list.result);
            this.changeDetectorRef.detectChanges();
          })
		 ); 
    }
    
    selectChanged(event) {

		this.disabledPanier=true;
        this.element = []
		let _options ={
			demande: false
		}
		let oo:any[]=Object.keys(event);
		let cpt:number=0;        
        let Event:any[]=Object.values(event)
        for (let i=0;i<Event.length;i++){
            this.instructionService.get(Event[i]["instruction.id"],_options).subscribe((res: JSONRpcResponse) => {
                if (res.result && res.result.type) {
                    let line:PanierLine=new PanierLine();                        
                    if (res.result.demande!=undefined)
                        if(res.result.demande.dossier!=undefined)
                            line.dossier=res.result.demande.dossier.tiers;
                    if (res.result.type!=undefined){
                        line.instruction=res.result;
                    }
                    this.element.push(line);                       
                    cpt++;
                    if (cpt==oo.length)
                        this.disabledPanier=false;
                        
                    this.changeDetectorRef.detectChanges();
                }
			})
        }
	}
	
	exporter(format:string) {
						 
							let _options:any = 			{
						            pageSize:this.PaginationNotification,
						            sorts: [this.sortNotification],
						            filters: {
						                zone: {value:this.parameters.zoneInput},
						                tiers: {value:this.parameters.tiersInput},
						                metier : {value:this.parameters.metierInput},
						                enCours : {value:this.parameters.enCoursInput},
						                procedure : {value:this.parameters.procedureInput},
						                action : {value:this.parameters.actionInput},
						                statut : {value:this.parameters.statutInput},
						                commune : {value:this.parameters.communeInput},
										alltiers: {value:this.parameters.allTiersInput},
										grouptiers: {value:this.parameters.allGroupTiersInput},
										groupListtiers: {value:this.parameters.allGroupTiersListInput},
						            },
									format: format
						        };
							
							
							   this.loadingNotification = true;
							   console.log('before export NOTIFICATION',_options);
							   this.listeService.export('NOTIFICATION', _options)
							     .subscribe(  (myexport) => {
							       this.loadingNotification = false;
							       console.log('export NOTIFICATION',myexport);
							       
							       if (myexport.result!=undefined
							        && myexport.result.datas!=undefined
							        && myexport.result.datas.file!=undefined) {
										const dial=this.dialogService.open(LoadDialogComponent, {
												               data: {
												                   url: myexport.result.datas.file
												               },
															   height: "95vh",
															   width: "80%",
															   minimizable: true,
															   maximizable: true,
															   draggable: true,
												           }, (res: any) => {
												               
												           })
										
							            //window.open(myexport.result.datas.file, '_blank');
										
									}	
							       this.changeDetectorRef.detectChanges();
							   });
				
	}	  
    
}
